export default __webpack_public_path__ + "static/media/LightBulbsCompared1.befe00e8.png";